import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.326.073a.146.146 0 0 0-.252 0C5.468 2.99 4.31 4.535 1.989 6.905a.135.135 0 0 0 0 .19c2.321 2.37 3.48 3.914 5.085 6.832a.145.145 0 0 0 .252 0c1.605-2.918 2.763-4.462 5.085-6.832a.135.135 0 0 0 0-.19C10.09 4.535 8.931 2.991 7.326.073"
    }, null, -1)
  ])))
}
export default { render: render }